import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import {
  ModalContainer,
  Theme,
  ThemeProvider,
  ToastContainer,
} from '@quality24/design-system';
import { MaintenanceModeProvider } from '@quality24/react-maintenance-mode';
import AuthProvider from '@/inpatient-patient-pwa/contexts/auth/AuthProvider';
import LanguageProvider from '@/inpatient-patient-pwa/contexts/language/LanguageProvider';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import Router from './routes/Router';

import ExtendedApolloProvider from './providers/ExtendedApolloProvider';
import { MaintenanceMode } from './components/molecules/MaintenanceMode';
import { headers } from './services/http';
import { defaultTheme } from './styles/theme';
import runtimeConfig from './config';

// Initialize i18n (react-i18next) before rendering. This also sets up the
// dynamic moment.locale sync via src/i18n/sideEffects.
import '@/inpatient-patient-pwa/i18n/index';

import '@quality24/design-system/src/styles/global.scss';
import './styles/global.scss';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MaintenanceModeProvider
        apiURL={runtimeConfig.API_URL || process.env.REACT_APP_API_URL || ''}
        headers={headers}
      >
        <ExtendedApolloProvider
          apiURL={runtimeConfig.API_URL || process.env.REACT_APP_API_URL || ''}
        >
          <AuthProvider>
            <LanguageProvider>
              <ThemeProvider theme={defaultTheme as Partial<Theme>}>
                <ModalContainer />
                <Router />
                <MaintenanceMode />
                <ToastContainer />
              </ThemeProvider>
            </LanguageProvider>
          </AuthProvider>
        </ExtendedApolloProvider>
      </MaintenanceModeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register(`${process.env.PUBLIC_URL}/firebase-sw.js`);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
